import React from 'react';
import PropTypes from 'prop-types';

import { preventDefault } from '../../services/click-handling';
import Tooltip from '../tooltip';
import { isOverflowing } from '../../services/is-overflowing';
import styles from './member-name.scss';
import { Button } from '../button';

const classNames = require('classnames');

export class MemberName extends React.Component {
  state = { isNameTooltipVisible: false };

  componentDidMount() {
    this.updateNameTooltipVisibility();
  }

  componentWillReceiveProps() {
    this.updateNameTooltipVisibility();
  }

  updateNameTooltipVisibility() {
    const isNameTooltipVisible = isOverflowing(this.nameWrapper);

    if (this.state.isNameTooltipVisible !== isNameTooltipVisible) {
      this.setState({ isNameTooltipVisible });
    }
  }

  setNameWrapper = (ref) => (this.nameWrapper = ref);

  renderName = (name) => (this.props.namePlain ? this.renderNamePlain(name) : this.renderNameAsUrl(name));

  renderNameAsUrl(name) {
    const { member, goToMemberPage, className, id } = this.props;

    return (
      <div ref={this.setNameWrapper}>
        <Button
          id={id}
          onClick={preventDefault(() => goToMemberPage(member.uid))}
          className={classNames(className, 'ma-members-name-font', styles.nameButton)}
          dataHook="memberBox.name"
        >
          {name}
        </Button>
      </div>
    );
  }

  renderNamePlain = (name) => (
    <span
      ref={this.setNameWrapper}
      id={this.props.id}
      className={classNames(this.props.className, 'ma-primary-font', 'ma-members-name-font', styles.nameButton)}
    >
      {name}
    </span>
  );

  renderNameWithTooltip = (name) => (
    <Tooltip text={name} className={this.props.tooltipClass}>
      {this.renderName(name)}
    </Tooltip>
  );

  render = () =>
    this.state.isNameTooltipVisible ? this.renderNameWithTooltip(this.props.name) : this.renderName(this.props.name);
}

MemberName.propTypes = {
  id: PropTypes.string,
  member: PropTypes.object,
  goToMemberPage: PropTypes.func,
  className: PropTypes.string,
  name: PropTypes.string,
  namePlain: PropTypes.bool,
  tooltipClass: PropTypes.string,
};

MemberName.defaultProps = {
  namePlain: false,
};

export default MemberName;
